<div class="modal-container">
  <div class="modal-header">
    <div>{{ 'modal.create_device.title' | translate }}</div>
    <div class="modal-header-close-btn icon-close" (click)="cancel()"></div>
  </div>

  <div class="seperator">
    <hr />
  </div>

  <div class="modal-body">
    <div class="modal-instruction">
      {{ 'modal.create_device.instruction' | translate }}
    </div>

    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="status-card" *ngIf="loadingTemplates">
      {{ 'modal.create_device.loading_templates' | translate }}
    </div>

    <div
      class="status-card"
      *ngIf="!loadingTemplates && templates.length === 0"
    >
      {{ 'modal.create_device.no_templates' | translate }}
    </div>

    <app-autocomplete
      *ngIf="!loadingTemplates && templates.length > 0"
      [data]="templates"
      propertyName="displayName"
      [label]="'modal.create_device.template' | translate"
      [isRequired]="true"
      [clearable]="true"
      [disabled]="creatingDevice || hasCreatedDevice"
      (valueSelected)="onTemplateSelected($event)"
    ></app-autocomplete>

    <div class="template-description" *ngIf="selectedTemplate?.description">
      {{ selectedTemplate?.description }}
    </div>

    <div class="metadata-fields" [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>{{
          'modal.create_device.id_strategy' | translate
        }}</mat-label>
        <mat-select
          formControlName="unitIdStrategy"
          required
          (selectionChange)="onUnitIdStrategySelected($event.value)"
        >
          <mat-option
            *ngFor="let strategy of unitIdStrategies"
            [value]="strategy.value"
          >
            {{ strategy.labelKey | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <app-qs-input
        *ngIf="isExplicitUnitIdStrategy"
        [label]="'modal.create_device.unit_id' | translate"
        [placeholder]="'modal.create_device.unit_id_placeholder' | translate"
        type="number"
        controllerName="unitId"
        [outlined]="true"
        [required]="true"
      ></app-qs-input>

      <app-qs-input
        [label]="'modal.create_device.name' | translate"
        [placeholder]="'modal.create_device.name_placeholder' | translate"
        controllerName="name"
        [outlined]="true"
      ></app-qs-input>

      <app-qs-input
        [label]="'modal.create_device.description' | translate"
        [placeholder]="
          'modal.create_device.description_placeholder' | translate
        "
        controllerName="description"
        [multiline]="true"
        [outlined]="true"
      ></app-qs-input>

      <div class="status-card" *ngIf="loadingCompanies">
        {{ 'modal.create_device.loading_companies' | translate }}
      </div>

      <app-autocomplete
        *ngIf="!loadingCompanies && companies.length > 0"
        [data]="companies"
        propertyName="name"
        optionValuePropertyName="id"
        [label]="'modal.create_device.company' | translate"
        [clearable]="true"
        [disabled]="creatingDevice"
        [formatterFn]="companyFormatter"
        (valueSelected)="onCompanySelected($event)"
      ></app-autocomplete>
    </div>

    <div class="actions">
      <app-button
        [small]="true"
        [title]="'modal.create_device.cancel' | translate"
        [disabled]="creatingDevice"
        (click)="cancel()"
      ></app-button>
      <app-button
        [small]="true"
        [black]="true"
        [title]="submitButtonTitle | translate"
        [disabled]="!selectedTemplate || form.invalid || creatingDevice"
        (click)="confirm()"
      ></app-button>
    </div>
  </div>
</div>
